import { Field } from '@snsw-gel/field'
import { deprecatedComponent } from '@snsw-gel/utils'

export const FormGroup = deprecatedComponent('FormGroup', Field)
